import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dropdown, Space, Typography } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';

const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'pt', label: 'Português', flag: '🇧🇷' }
];

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();
  const current = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

  const items = LANGUAGES.map(lang => ({
    key: lang.code,
    label: (
      <Space>
        <span style={{ fontSize: 20 }}>{lang.flag}</span>
        <Typography.Text>{lang.label}</Typography.Text>
      </Space>
    ),
    onClick: () => i18n.changeLanguage(lang.code)
  }));

  return (
    <Dropdown menu={{ items }} placement="bottomRight">
      <Button type="text" icon={<GlobalOutlined />}>
        <Space>
          <span style={{ fontSize: 20 }}>{current.flag}</span>
        </Space>
      </Button>
    </Dropdown>
  );
};

export default LanguageSelector; 